import React from 'react';
import './faq.css';

const faqData = [
  {
    q: "What services does JRP Soft Tech provide?",
    a: "JRP Soft Tech provides SaaS development, AI automation, drone services, robotics solutions, website development, mobile app development, and custom software solutions for startups and enterprises."
  },
  {
    q: "Do you offer MVP development within 24 hours?",
    a: "Yes, we specialize in rapid MVP (Minimum Viable Product) development within 24 hours with deployment. This helps startups validate ideas quickly and launch faster."
  },
  {
    q: "What SaaS products do you offer?",
    a: "We offer CRM software, ERP systems, invoicing and billing software, subscription management systems, and e-commerce SaaS platforms."
  },
  {
    q: "Do you build custom CRM and ERP systems?",
    a: "Yes, we develop fully customized CRM and ERP solutions tailored to your business workflows, automation needs, and scalability requirements."
  },
  {
    q: "Do you provide website development services?",
    a: "Yes, we design and develop SEO-friendly, high-performance websites for businesses, startups, and e-commerce platforms."
  },
  {
    q: "Do you develop mobile applications?",
    a: "Yes, we build Android and iOS mobile applications using modern technologies like Flutter and React Native."
  },
  {
    q: "Can you build e-commerce platforms?",
    a: "Yes, we create scalable e-commerce platforms with payment integration, product management, and order tracking systems."
  },
  {
    q: "What technologies do you specialize in?",
    a: "We use React, Angular, Flutter, Node.js, ReactNative, Python, PHP, Java, Kotlin,JavaScript, AI/ML, cloud computing, and modern databases to build scalable and secure applications."
  },
  {
    q: "Do you offer AI automation solutions?",
    a: "Yes, we provide AI chatbots, workflow automation, and business intelligence solutions to improve efficiency and reduce operational costs."
  },
  {
    q: "Do you provide drone services?",
    a: "Yes, we offer drone services including land survey, mapping, agriculture spraying, surveillance, and aerial photography."
  },
  {
    q: "What industries do you serve?",
    a: "We serve real estate, agriculture, healthcare, logistics, education, e-commerce, startups, and government sectors."
  },
  {
    q: "How long does it take to develop custom software?",
    a: "Timelines depend on project complexity. MVPs can be delivered within 24 hours, while full-scale systems may take weeks or months."
  },
  {
    q: "Do you provide support after deployment?",
    a: "Yes, we offer maintenance, updates, and technical support to ensure smooth operation of your software."
  },
  {
    q: "Do you offer subscription-based software?",
    a: "Yes, we provide subscription-based SaaS solutions including CRM, ERP, billing systems, and automation tools."
  },
  {
    q: "How can I get started with JRP Soft Tech?",
    a: "You can contact us through our website or request a demo. Our team will guide you from idea to deployment."
  }
];

const Faq = () => {
  return (
    <section className="faq" id="faq">
      <h2>Frequently Asked Questions </h2>
      
      <p className="section-desc">
        Learn more about our CRM, ERP, invoicing software, SaaS products, AI automation, website and mobile app development services.
      </p>

      {/* ✅ FULL SEO FAQ SCHEMA */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqData.map(item => ({
            "@type": "Question",
            "name": item.q,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": item.a
            }
          }))
        })}
      </script>

      <div className="faq-container">
        <div className="faq">
          {faqData.map((item, index) => (
            <div className="faq-item" key={index}>
              <input type="checkbox" id={`faq${index}`} />
              
              <label htmlFor={`faq${index}`} className="faq-item-title">
                <span className="icon"></span>
                {item.q}
              </label>

              <div className="faq-item-desc">
                {item.a}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;